"use client"
import React from "react";
import { Image, Media } from "react-bootstrap";
import "@/components/shared/MetadataThumbnail.css";
import "@/components/shared/CurrencySymbols.css";
import GoToLink from "@/components/shared/GoToLink";

const MetadataThumbnail = ({
  image,
  metadata,
  url,
  short,
  clickable,
  verticalLayout,
  className,
  ownerId,
  contentId,
  type
}) => {
  const isUrl = url => {
    var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;
    var regex = new RegExp(expression);
    return url.match(regex);
  };

  const theUrl = url;
  const title = metadata
    ? metadata.og && metadata.og.title
      ? metadata.og.title
      : metadata.root.title
    : null;
  const description = metadata
    ? metadata.og && metadata.og.description
      ? metadata.og.description
      : metadata.root.description
    : null;
  const ogImage = metadata
    ? metadata.og && metadata.og.image
      ? metadata.og.image
      : null
    : null;
  const price = metadata
    ? metadata.product &&
      metadata.product.hasOwnProperty("price:amount") &&
      metadata.product.hasOwnProperty("price:currency")
      ? `${metadata.product["price:amount"]} ${metadata.product["price:currency"]}`
      : null
    : null;
  const currency = metadata
    ? metadata.product &&
      metadata.product.hasOwnProperty("price:amount") &&
      metadata.product.hasOwnProperty("price:currency")
      ? `${metadata.product["price:currency"]}`
      : "USD"
    : null;

  const isThisAUrl = isUrl(theUrl);

  var urlObject;
  var hostname;
  if (isThisAUrl) {
    urlObject = new URL(theUrl);
    hostname = urlObject.hostname;
  }

  const content = (
    <div className="default-card-wrapper-content metadata-thumbnail">
      <div className={`media ${verticalLayout ? "vertical-layout" : ""}`}>
        {image && ogImage && isUrl(ogImage) && <Image src={ogImage} />}
        <div className="media-body">
          {!short && (
            <>
              <h4>{title ? title : "Untitled"}</h4>
              <span className="hostname">{hostname}</span>
              <br />
              <span>{description}</span>
              <br />
              {price && currency && (
                <p>
                  <span className={`currency-symbol-${currency}`}></span>
                  {price}
                </p>
              )}
            </>
          )}
          {short && (
            <>
              <h4>
                {title && title.length > 40
                  ? title.substring(0, 39) + ".."
                  : title
                  ? title
                  : "Untitled"}
              </h4>
              <span className="hostname">{hostname}</span>
              <br />
              <span>
                {description && description.length > 110
                  ? description.substring(0, 109) + ".."
                  : description}
              </span>
              <br />
              {price && currency && (
                <p>
                  <span className={`currency-symbol-${currency}`}></span>
                  {price}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );

  if (isThisAUrl) {
    return (
      <>
        {theUrl && (
          <div className={className ?? "default-card-wrapper"}>
            {clickable && (
              <GoToLink
                classProps="style-as-div"
                ownerId={ownerId}
                contentId={contentId}
                type={type}
                url={theUrl}
                toRender={content}
              />
            )}
            {!clickable && <>{content}</>}
          </div>
        )}
        {!theUrl && <p className="error">No preview available.</p>}
      </>
    );
  } else {
    return null;
  }
};
export default MetadataThumbnail;
